import script from "./BlockHintAddTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockHintAddTicker.vue?vue&type=script&setup=true&lang=js"

import "./BlockHintAddTicker.vue?vue&type=style&index=0&id=2422ca8c&lang=scss"

const __exports__ = script;

export default __exports__